import React from 'react';
import PracticeExamScreen from '../../src/screens/progress/PracticeExamScreen';

export default function PracticeExamRoute() {
  return <PracticeExamScreen />;
}
